import { Component, OnInit,Output, EventEmitter, AfterViewInit, Injectable } from '@angular/core';
// import {LoadingModule};
import { HttpClient, HttpHeaders } from '@angular/common/http';

import {NgForm} from '@angular/forms';

 //import { InstiComponent } from './insti/insti.component';
 
import { instiRoutehandle } from './insti/instiRoutehandle.module';
import { InstiService } from './insti/insti.service';
//import {instiLoading} from './insti/instiLoading.module';

import { Location } from '@angular/common';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
/*
 * 
 */
export class AppComponent{
   // is_loading: boolean=true;
//     @Output() is_loading: EventEmitter<any> = new EventEmitter();
//     loadObj: instiLoading;
//    constructor(
//		protected insti_route?:instiRoutehandle,
//		protected service?: InstiService,
//		protected location?: Location,
//	){
//		 this.loadObj=new instiLoading();  
//	}
// 
//	ngAfterViewInit(){	
//	}
//
//	 ngOnInit(){
//	 }
    
    /*
	constructor(
		protected insti_route?:instiRoutehandle,
		protected service?: InstiService,
		protected location?: Location,
	){
		super();
		this.setListOnStart(false);
	}
 
	ngAfterViewInit(){
	super.ngAfterViewInit();
	return this;
	}

	 ngOnInit(){

		super.ngOnInit();
	 }
*/
  getWidth (): any {
		if (document.body.offsetWidth <850) {
			return '90% ' ;
		}
		
		return 850;
	}
/*	
onActivate(componentReference) {
   console.log('saddasdsds', componentReference);
   if(!componentReference.hasOwnProperty('is_loading')){
     return this;  
   }
   componentReference.is_loading.subscribe((data) => {
    this.is_loading=data;
     //loadObj.getIsLoading()
      // Will receive the data from child here 
   });  
 }
 */
 
 
}
